import { createTheme, MantineColorsTuple } from '@mantine/core';

// Hillside Harmony brand colors - teal and gold from logo
const harmony: MantineColorsTuple = [
  '#e6f4f7',
  '#cce9ed',
  '#99d3db',
  '#66bdc9',
  '#33a7b7',
  '#0091a5',
  '#007b8d',
  '#006b7d',
  '#005b6d',
  '#004b5d',
];

const gold: MantineColorsTuple = [
  '#faf7f2',
  '#f5efe5',
  '#ebe0cb',
  '#e0d0b1',
  '#d6c197',
  '#ccb17d',
  '#c2a163',
  '#b8985f',
  '#9e824f',
  '#846c3f',
];

export const theme = createTheme({
  primaryColor: 'harmony',
  colors: {
    harmony,
    gold,
  },
  fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  headings: {
    fontFamily: '"Playfair Display", Georgia, serif',
    fontWeight: '600',
  },
  defaultRadius: 'md',
  components: {
    Button: {
      defaultProps: {
        radius: 'md',
      },
    },
    Card: {
      defaultProps: {
        radius: 'lg',
        shadow: 'sm',
      },
    },
  },
});
